import { render } from "./CAPrepare.vue?vue&type=template&id=6b6153f0"
import script from "./CAPrepare.vue?vue&type=script&lang=js"
export * from "./CAPrepare.vue?vue&type=script&lang=js"
script.render = render

export default script